import { action, observable } from 'mobx';

import axios from 'axios';

class AccountInfoClass {
    @observable UsernameAlreadyInUse = false;


    @action setUsernameAlreadyInUse(bool) {
        if (typeof bool === 'boolean') {
            this.UsernameAlreadyInUse = bool;
        }
    }

    // Validate Username
    @action validateUsername(username, successCallback, errorCallback) {
        // verify username
        axios.get(`/api/User?username=${encodeURIComponent(username)}`)
            .then((response) => {
                // if user name is not available, set the error message flag
                this.setUsernameAlreadyInUse(!(response.data && response.data.IsAvailable));
                successCallback(response);
            }).catch((err) => {
                errorCallback(err);
                return err;
            });
    }
}


const accountInfoStore = new AccountInfoClass();
export { accountInfoStore, AccountInfoClass };
